<div class="main-div" [ngClass]="{'blur-background' : displayStyle === 'block'}">
  <div class="">
    <div class="mobile-heading">
      <h3 class="fw-bold mb-0">Blog List</h3>
    </div>
    <div class="top-nav">
      <div class="desktop-heading">
        <h3 class="fw-bold">Blog List</h3>
      </div>
      <div></div>
      <div class="top-nav-menu-item-container">
        <div class="top-nav-menu-item">
          <i class="fas fa-plus"></i>
          <span (click)="addBlog()">New</span>
        </div>

        <div class="top-nav-menu-item">
          <i class="fas fa-sign-out-alt"></i>
          <span (click)="logout()">LogOut</span>
        </div>
      </div>
    </div>
  
    <p-divider />

    <div class="col-12 col-sm-5 col-lg-4 row search_filter ms-2 ms-sm-3 mt-3 mb-3">
      <input pInputText class="pt-1 pb-1 w-100" placeholder="search blog" (input)="applyFilter($event, blogTable)" />
    </div>
  </div>
  
  <div class="table-container">
    <p-table
      #blogTable
      [value]="allBlog"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 25, 100]"
      [globalFilterFields]="['author', 'category', 'description', 'srNo']"
      sortMode="single"
      sortField="srNo"
      [sortOrder]="1"
      [tableStyle]="{ 'min-width': '100%' }"
      aria-label="Blog list">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="srNo" class="d-none d-md-table-cell">
            Sr. No.
            <p-sortIcon field="srNo" />
          </th>
          <th pSortableColumn="author" class="d-none d-md-table-cell">
            Author
            <p-sortIcon field="author" />
          </th>
          <th pSortableColumn="category" class="d-none d-md-table-cell">
            Category
            <p-sortIcon field="category" />
          </th>
          <th pSortableColumn="description" class="d-none d-md-table-cell">
            Description
            <p-sortIcon field="description" />
          </th>
          <th class="d-none d-md-table-cell">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element>
        <tr>
          <td class="d-block d-md-table-cell mb-3">
            <span class="td-before col-12">Sr. No</span>
            <span class="col-12 d-flex">{{ element.srNo }}</span>
          </td>
          <td class="d-block d-md-table-cell mb-3">
            <span class="td-before col-12">Author</span>
            <span class="col-12 d-flex">{{ element.author }}</span>
          </td>
          <td class="d-block d-md-table-cell mb-3">
            <span class="td-before col-12">Category</span>
            <span class="col-12 d-flex">{{ element.category }}</span>
          </td>
          <td class="d-block d-md-table-cell mb-3">
            <span class="td-before col-12">Description</span>
            <span class="col-12 d-flex">{{ element.description }}</span>
          </td>
          <td class="d-block d-md-table-cell mb-3">
            <i class="fas fa-edit col-1 col-md-2 fs-6" (click)="updateBlog(element)"
              style="color:var(--oranges--orange-600);"></i>
            <i class="fas fa-trash col-1 col-md-2 ps-1 fs-6" (click)="deleteBlog(element.blogID)"
              style="color:var(--oranges--orange-600);" aria-label="delete"></i>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="mb-4">No data matching the filter.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

  
